import React, { useMemo, useState, useEffect } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const SegmentSpeakerDialog = ({
  open,
  onOpenChange,
  segment,
  segmentIndex,
  speakers = [],
  language = "es",
  onSave,
  loading = false,
}) => {
  const [selection, setSelection] = useState("");

  useEffect(() => {
    if (!open) return;
    setSelection(segment?.speaker_id || "");
  }, [open, segment]);

  const copy = useMemo(() => language === "es" ? {
    title: "Mover segmento a otro speaker",
    description: "Úsalo para dividir speakers mezclados o corregir segmentos mal asignados.",
    createNew: "Crear speaker nuevo",
    save: "Guardar cambio",
  } : {
    title: "Move segment to another speaker",
    description: "Use this to split mixed speakers or fix wrongly assigned segments.",
    createNew: "Create new speaker",
    save: "Save change",
  }, [language]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="segment-speaker-dialog">
        <DialogHeader>
          <DialogTitle data-testid="segment-speaker-dialog-title">{copy.title}</DialogTitle>
          <DialogDescription data-testid="segment-speaker-dialog-description">{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-2xl border border-border bg-muted/20 p-4" data-testid="segment-speaker-dialog-segment-card">
            <p className="mb-2 text-xs text-muted-foreground">#{segmentIndex}</p>
            <p className="text-sm leading-6 text-foreground">{segment?.text}</p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium" htmlFor="segment-speaker-select">Speaker</label>
            <select
              id="segment-speaker-select"
              className="w-full rounded-xl border border-border bg-background px-3 py-2 text-sm"
              value={selection}
              onChange={(event) => setSelection(event.target.value)}
              data-testid="segment-speaker-select"
            >
              {speakers.map((speaker) => (
                <option key={speaker.speaker_id} value={speaker.speaker_id}>
                  {speaker.custom_name || speaker.label}
                </option>
              ))}
              <option value="__new__">{copy.createNew}</option>
            </select>
          </div>

          <div className="flex justify-end">
            <Button
              type="button"
              onClick={() => onSave?.(selection)}
              disabled={!selection || loading}
              data-testid="segment-speaker-save-button"
            >
              {copy.save}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};